<div class="col-md-12 col-sm-12 col-12 wd-kanban no-padding">
  <ng-scrollbar visibility="hover" #scrollable tr track="all" pointerEventsMethod="scrollbar">
    <app-content-kanban></app-content-kanban>
  </ng-scrollbar>
</div>
